import moment from 'moment-timezone'
import da from "element-ui/src/locale/lang/da";
import store from '@/store'


export function isToday(date) {
	if (!date) return
	return fomatTime(date) === fomatTime(new Date())
}

// export function getWeekOfYear(date) {
// 	// 将日期转换为ISO标准日期
// 	date.setHours(0, 0, 0, 0);
// 	date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  
// 	// 获取年份的第一天
// 	var yearStart = new Date(date.getFullYear(), 0, 1);
  
// 	// 计算当前日期是今年的第几周
// 	var weekNumber = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
  
// 	// 限制周数在1到52之间
// 	return Math.min(52, Math.max(1, weekNumber));
// }

export function getWeekOfYear(date) {
	// 将日期转换为ISO标准日期
	date.setHours(0, 0, 0, 0);
  
	// 获取日期的年份
	var year = date.getFullYear();
  
	// 获取年份的第一天
	var yearStart = new Date(year, 0, 1);
  
	// 计算当前日期是今年的第几天
	var dayOfYear = Math.floor((date - yearStart) / 86400000) + 1;
  
	// 计算当前日期是今年的第几周
	var weekNumber = Math.ceil(dayOfYear / 7);
  
	// 如果当前日期是上一年的最后一周，但是跨年了，修正为第一周
	if (date < new Date(year, 0, 1 + (7 - yearStart.getDay()))) {
	  weekNumber = 1;
	}
  
	// 限制周数在1到52之间
	return Math.min(52, Math.max(1, weekNumber));
  }

//计算本年的周数
export function getYearWeek(endDate) {
	// if (!endDate) return
	// //本年的第一天
	// let beginDate = new Date(endDate.getFullYear(), 0, 1);
	// //星期从0-6,0代表星期天，6代表星期六
	// let endWeek = endDate.getDay();
	// if (endWeek == 0) endWeek = 7;
	// let beginWeek = beginDate.getDay();
	// if (beginWeek == 0) beginWeek = 7;
	// //计算两个日期的天数差
	// let millisDiff = endDate.getTime() - beginDate.getTime();
	// let dayDiff = Math.floor((millisDiff + (beginWeek - endWeek) * (24 * 60 * 60 * 1000)) / 86400000);
	// let weekNum =  Math.ceil(dayDiff / 7) + 1;
	// return weekNum;
	return getWeekOfYear(endDate);
}


export function getRangeOfMonth(date) {
	return [new Date(date.getFullYear(), date.getMonth(), 1), new Date(date.getFullYear(), date.getMonth() + 1, 0)];
}


export function getYearWeekCompletion(endDate) {
	let weekNum = getYearWeek(endDate)
	return weekNum < 10 ? '0' + weekNum : weekNum
}

export function dateAdd(date, interval, number) {
	if (!date) return;
	number = parseInt(number);
	switch (interval) {
		case "y":
			date.setFullYear(date.getFullYear() + number);
			break;
		case "m":
			date.setMonth(date.getMonth() + number);
			break;
		case "d":
			date.setDate(date.getDate() + number);
			break;
		case "w":
			date.setDate(date.getDate() + 7 * number);
			break;
		case "h":
			date.setHours(date.getHours() + number);
			break;
		case "n":
			date.setMinutes(date.getMinutes() + number);
			break;
		case "s":
			date.setSeconds(date.getSeconds() + number);
			break;
		case "l":
			date.setMilliseconds(date.getMilliseconds() + number);
			break;
	}
	return date;
}

export function getWeekFirstDay(date) {
	if (!date) return
	return new Date(date.setDate(date.getDate() - date.getDay()));
}

export function getWeekLastDay(date) {
	if (!date) return
	return new Date(date.setDate(date.getDate() - date.getDay() + 6));
}

export function fomatTime(date, format = 'YYYY-MM-DD') {
	return moment(date).format(format)
}

export function fomatTimeStr(date) {
	if (!date) return
	let d = new Date(date)
	let str = ""
	// if (store.state.app.language == 'zh-CN') {
	// 	str += d.getFullYear() + "\t"
	// 	str += "第" + getYearWeekCompletion(d) + "周\t"
	// 	str += "(" + fomatTime(getWeekFirstDay(d), 'MM/DD') + "~" + fomatTime(getWeekLastDay(d), 'MM/DD') + ")"
	// } else {
	// 	str = "Week " + getYearWeekCompletion(d) + " | " + "\t"
	// 	str += fomatTime(getWeekFirstDay(d), 'MM/DD') + "~" + fomatTime(getWeekLastDay(d), 'MM/DD') + ", " + d.getFullYear()
	// }
	let yearWeekCompletion = getYearWeekCompletion(getWeekLastDay(d));
	let weekFirstDay = fomatTime(getWeekFirstDay(d), 'MM/DD');
	let weekLastDay = fomatTime(getWeekLastDay(d), 'MM/DD');

	if (store.state.app.language == 'zh-CN') {
		str = `${d.getFullYear()}\t第${yearWeekCompletion}周\t(${weekFirstDay}~${weekLastDay})`;
	} else {
		str = `Week\t${yearWeekCompletion}\t|\t${weekFirstDay}~${weekLastDay},\t${d.getFullYear()}`;
	}
	return str
}

export function getDistanceTime(date1, date2) {
	let new_date = new Date(date1); //新建一个日期对象，默认现在的时间
	let old_date = new Date(date2); //设置过去的一个时间点，"yyyy-MM-dd HH:mm:ss"格式化日期

	let difftime = (new_date - old_date) / 1000; //计算时间差,并把毫秒转换成秒

	let days = parseInt(difftime / 86400); // 天  24*60*60*1000
	let hours = parseInt(difftime / 3600) - 24 * days;    // 小时 60*60 总小时数-过去的小时数=现在的小时数
	let minutes = parseInt(difftime % 3600 / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
	let seconds = parseInt(difftime % 60);  // 以60秒为一整份 取余 剩下秒数

	let arr = [days, hours]

	return arr
}

// 是否是周末
export function isWeekend(date) {
	return date.getDay() === 0 || date.getDay() === 6
}

export function getMonthEnd(date) {
	if (!date) return null
	if (!date instanceof Date) date = new Date(date)
	return new Date(date.getFullYear(), date.getMonth() + 1, 1)
}

export function isLeapYear(year) {
	return year % 100 != 0 && year % 4 == 0 || year % 400 == 0;
}

// 获取某月的天数
export function mGetDate(date) {
	let year = date.getFullYear();
	let month = date.getMonth() + 1;
	let d = new Date(year, month, 0);
	return d.getDate();
}

// 获取某月的周数
export function getWeeks(date) {
	var d = new Date();
	// 该月第一天
	d.setFullYear(date.getFullYear(), date.getMonth(), 1);
	var w1 = d.getDay();
	if (w1 == 0) w1 = 7;
	// 该月天数
	d.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
	var dd = d.getDate();
	// 第一个周一
	let d1;
	if (w1 != 1) d1 = 7 - w1 + 2;
	else d1 = 1;
	let week_count = Math.ceil((dd - d1 + 1) / 7);
	return week_count;
}


export function getMonthWeek(theDate) {
	let currentDay = new Date(theDate);
	// 获取该日期所在周的周六，如2019.5月的周六有4号、11号、18号、25号、31号
	let theSaturday = currentDay.getDate() + (6 - currentDay.getDay());
	return Math.ceil(theSaturday / 7);
}


export function getMonthName(month) {
	let monthName = "";
	switch (month) {
		case 1:
			monthName = "January";
			break;
		case 2:
			monthName = "February";
			break;
		case 3:
			monthName = "March";
			break;
		case 4:
			monthName = "April";
			break;
		case 5:
			monthName = "May";
			break;
		case 6:
			monthName = "June";
			break;
		case 7:
			monthName = "July";
			break;
		case 8:
			monthName = "August";
			break;
		case 9:
			monthName = "September";
			break;
		case 10:
			monthName = "October";
			break;
		case 11:
			monthName = "November";
			break;
		case 12:
			monthName = "December";
			break;
	}
	return monthName;
}